import { cn } from '@/lib/utils';
import {
  BillRowVm,
  BillSectionVm,
} from '@/features/dashboard/bookingChanges/types/BillViewModel.ts';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import BillRow from '../billRow';
import { billGridClass } from '../billGrid';

interface BillSectionPanelProps {
  section: BillSectionVm;
  isEditing: boolean;
  onRowAction?: (row: BillRowVm) => void;
  onAddManualRow?: () => void;
}

/**
 * Rozwinięta sekcja: siatka wierszy, przypis i dopisywanie wolnej linii.
 *
 * `@container` stąd, bo to szerokość tej ramki decyduje, czy wiersz mieści się
 * w czterech kolumnach — patrz `billGrid.ts`.
 */
const BillSectionPanel = ({
  section,
  isEditing,
  onRowAction,
  onAddManualRow,
}: BillSectionPanelProps) => {
  const rowCount = section.rows.length;

  return (
    <div className="@container">
      <div className={cn(billGridClass, 'items-center px-[18px]')}>
        {section.rows.map((row, index) => (
          <BillRow
            key={row.id}
            row={row}
            isEditing={isEditing}
            isLast={index === rowCount - 1}
            onAction={onRowAction}
          />
        ))}
      </div>

      {section.note && (
        <div className="text-pretty px-[18px] pb-3.5 text-[13px] text-neutral-500">
          {section.note}
        </div>
      )}

      {section.allowAdd && isEditing && (
        <div className="px-[18px] pb-4">
          <ActionButton tone="dashed" size="sm" onClick={onAddManualRow}>
            + Wolna linia
          </ActionButton>
        </div>
      )}
    </div>
  );
};

export default BillSectionPanel;
